import * as yup from "yup";

import { UserProfileDeletionReasonEnum } from "api";

export enum DeleteReason {
  MissingFunctionality = "Бракує важливого для мене функціоналу",
  InconvenientInterface = "Складно розібратися, як працює сервіс",
  NotNeededCurrently = "Сервіс цікавий, але поки що не актуальний для мене",
  InsufficientSupport = "Служба підтримки не надала необхідної допомоги",
  Other = "Інша причина",
}

export const reasonLabelToEnum: Record<
  DeleteReason,
  keyof typeof UserProfileDeletionReasonEnum
> = {
  [DeleteReason.MissingFunctionality]: "MissingFunctionality",
  [DeleteReason.InconvenientInterface]: "InconvenientInterface",
  [DeleteReason.NotNeededCurrently]: "NotNeededCurrently",
  [DeleteReason.InsufficientSupport]: "InsufficientSupport",
  [DeleteReason.Other]: "Other",
};

export type FormValues = {
  reason: DeleteReason[];
  notes?: string;
};

export const validationSchema = yup.object({
  reason: yup.array().min(1, "Вкажіть причину").required("Вкажіть причину"),
  notes: yup.string().when("reason", ([reason], schema) => {
    return reason.includes(DeleteReason.Other)
      ? schema.required("Вкажіть іншу причину")
      : schema;
  }),
});
